import { Landmark, Building2 } from "lucide-react";
import Reveal, { Stagger, StaggerItem } from "@/components/motion/Reveal";

export default function WhoWeServe() {
  return (
    <section id="who-we-serve" data-testid="who-we-serve-section" className="relative bg-[#0A0A0D] py-32 md:py-40 border-t border-white/8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="mb-14 max-w-3xl">
          <div className="overline mb-6">Government &amp; Corporates</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-neutral-50">
            Structured for <span className="italic text-[#D4AF37]">institutional</span> land requirements.
          </h2>
          <p className="mt-6 text-neutral-400 leading-relaxed">
            The house serves two categories of counterparties. Our capabilities are described here as use-cases; specific engagements are held in confidence.
          </p>
        </Reveal>
        <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-6" gap={0.12}>
          <StaggerItem>
            <div className="border border-white/8 p-10 md:p-12 bg-[#121215] h-full">
              <Landmark strokeWidth={1} className="w-8 h-8 text-[#D4AF37] mb-6" />
              <div className="overline mb-3">Government &amp; Public Institutions</div>
              <div className="font-display text-3xl md:text-4xl text-neutral-50 leading-tight">Land for public purpose.</div>
              <p className="mt-5 text-neutral-400 leading-relaxed">
                Support for land requirements connected with infrastructure, industrial development, public-sector expansion and related institutional programmes.
              </p>
            </div>
          </StaggerItem>
          <StaggerItem>
            <div className="border border-white/8 p-10 md:p-12 bg-[#121215] h-full">
              <Building2 strokeWidth={1} className="w-8 h-8 text-[#D4AF37] mb-6" />
              <div className="overline mb-3">Corporates &amp; Multinationals</div>
              <div className="font-display text-3xl md:text-4xl text-neutral-50 leading-tight">Sites for enterprise scale.</div>
              <p className="mt-5 text-neutral-400 leading-relaxed">
                Strategic land requirements associated with manufacturing, logistics, industrial facilities, data infrastructure, R&amp;D facilities and corporate expansion.
              </p>
            </div>
          </StaggerItem>
        </Stagger>
      </div>
    </section>
  );
}
